import { useState } from "react";
import { IoFlag } from "react-icons/io5";
import ReportModal from "./ReportModal";

// Only rendered for someone else's post (a design's own owner gets an
// Edit/Delete menu instead, not a report option) — logged-out visitors
// don't get the button at all, same as Comments' report action.
export default function ReportDesignButton({ designId, reporterId, style }) {
  const [reportOpen, setReportOpen] = useState(false);

  if (!reporterId) return null;

  return (
    <>
      <button onClick={() => setReportOpen(true)} style={style} aria-label="Report this design">
        <IoFlag />
      </button>

      {reportOpen && (
        <ReportModal
          reporterId={reporterId}
          targetType="design"
          targetId={designId}
          onClose={() => setReportOpen(false)}
        />
      )}
    </>
  );
}
